import React, { Component } from 'react';
import { Select, Input } from 'antd';
import AddCoinBtnComponent from './AddCoinBtnComponent';
// import Search from './Search'
import CoinTableComponent from './CoinTableComponent';
import DisplayControl from '../DisplayControl';
import AddCustomCoinBtnComponent from './AddCustomCoinBtnComponent';
import {debounce , isEmpty} from 'lodash';
import consts from '../../consts';
const { Option } = Select;

class CoinSettingComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      coin: 'ETH',
      coinSearch: '',
    };
  }

  handleChange = (coin) => {
    this.props.selectCoin(coin);
    this.setState({ coin: coin });
  };

  renderCoin = () => {
    return window._.map(this.props.arrCoins, (coin) => <Option value={coin.symbol}>
      {coin.symbol}
    </Option>);
  };
  onSearch = (event) => debounce((coinSearch) => {
    if (isEmpty(coinSearch)) {
      return this.setState({
        coinSearch: "",
      });
    }
    coinSearch = coinSearch.toUpperCase()
    this.setState({ coinSearch });
  }, 300)(event.target.value);


  render() {
    return (
      <div className="p-medium">
        <h3> Tiền điện tử </h3>
        <div className='d-flex space-between'>
          <div>
            <Select
            className="mr-medium"
              defaultValue=""
              style={{ width: 100 }}
              onChange={this.handleChange}
            >
              <Option value={''}>
                Tất cả
              </Option>
              {this.renderCoin()}
            </Select>
          <Input style={{ width: 260 }} onChange={this.onSearch} placeholder="Tìm kiếm"/>
          </div>
          
          <div className='d-flex'>
            <DisplayControl permission_link_screen={consts.AUTH.SETTING__COINS} action="POST">
              <AddCoinBtnComponent />
            </DisplayControl>
         <AddCustomCoinBtnComponent />
         </div>
        </div>
        <div style={{ marginTop: '20px' }}>
          <CoinTableComponent coinSearch={this.state.coinSearch}/>
        </div>
      </div>
    );
  }
}

export default CoinSettingComponent;
